export default () => ({
  total: 0,
  request_company: null,
})
